import auth from "@/pages/auth/i18n/en";
import dashboard from "@/pages/dashboard/i18n/en";
import time from "@/pages/time/i18n/en";
import leave from "@/pages/leave/i18n/en";
import hr from "@/pages/hr/i18n/en";
import feedback from "@/pages/pending-feedbacks/i18n/en";

export default {
  ...auth,
  ...dashboard,
  ...time,
  ...leave,
  ...hr,
  ...feedback,
  menu: {
    dashboard: "Dashboard",
    time: "Time",
    hr: "Human Resources",
    leave: "Time Off",
    clock_in_out: "Clock In / Out"
  },
  message: {
    saved_successfully: "Saved Successfully",
    updated_successfully: "Updated Successfully",
    deleted_successfully: "Deleted Successfully",
    download_email_report: "Click the download button to download the file",
    registration_successful: "Registration Successful",
    registration_failed: "Registration Failed",
    pass_reset_time_early: "You must wait at least 3 minute to request a new password reset token!",
    entity_not_found: "Account not found",
    pass_reset_leng_err: "Your password must be a minimum of 6 characters and a maximum of 16 characters."
  },
  global: {
    comment: "Comment",
    description: "Description",
    day: "Day",
    note: "Note",
    employee: "Employee",
    address: "Address",
    explanation: "Explanation",
    hour: "Hour",
    month: "Month",
    phone: "Phone",
    status: "Status",
    file: "File",
    greeting: "Hello, {0}",
    search_for_employee: "Search for employee...",
    others: "Others",
    importance_enum: {
      LOW: "Low",
      MEDIUM: "Medium",
      HIGH: "High"
    },
    importance: "Importance",
    date: "Date",
    loading_message: "Loading...",
    birth_date: "Birth Date",
    min_character_message: "You must enter {0} characters at least",
    no_employee_message: "No employee was found in the criteria you searched for.",
    employees: "Employees",
    beginDate: "Begin Date",
    endDate: "End Date",
    beginTime: "Begin Time",
    endTime: "End Time",
    year: "Year",
    message: "Message",
    country: "Country",
    active_employees: "Active Employees",
    passive_employees: "Passive Employees",
    maxEmployeeCount: "Max Employee Count",
    years_old: "years old",
    print: "Print",
    expense_management: "Expense Management",
    uploaded_files: "Uploaded Files",
    loading: "Loading...",
    employee_selected: "Select employee...|1 employee selected|{count} employees selected",
    shift_selected: "Select shift...|1 shift selected|{count} shifts selected",
    shifts_type: "{0} Shifts",
    total_hours: "Total Hours"
  },
  assessment: {
    very_poor: "Very Poor",
    poor: "Poor",
    normal: "Normal",
    good: "Good",
    very_good: "Very Good",
    na: "Not Assessment"
  },
  buttons: {
    home: "Dashboard",
    ok: "Ok",
    delete: "Delete",
    back: "Back",
    save: "Save",
    update: "Update",
    edit: "Edit",
    cancel: "Cancel",
    close: "Close",
    dont_save: "Exit without saving",
    dont_save_continue: "Continue without saving",
    save_changes: "Save Changes",
    evaluation_finish: "Finish Evaluation",
    assign: "Assign",
    add: "Add {0}",
    add_and_new: "Add and New",
    refresh: "Refresh",
    filter: "Filter",
    export: "Export",
    create: "Create {0}",
    create_and_new: "Create and New",
    download: "Download",
    yes: "Yes",
    no: "No",
    clear: "Clear",
    filter_results: "Filter Results",
    delete_document: "Delete Document",
    scan: "Scan",
    send_message: "Send Message",
    send: "Send",
    apply: "Apply",
    info: "Information",
    prev: "Previous {0}",
    next: "Next {0}",
    list_table: "Table Mode",
    list_card: "Card Mode",
    continue: "Continue",
    show_all: "Show All",
    cancel_leave: "Cancel Time Off",
    select_all: "Select All",
    upload: "Upload",
    file_upload: "File Upload",
    file_download: "File Operations",
    import: "Import",
    upload_template: "Upload Template",
    download_template: "Download Template",
    trigger: "Trigger",
    action: "Action",
    send_registration_credentials: "Send Registration Credentials",
    on: "On",
    off: "Off",
    uploads: {
      employee: "Import Employees",
      leave: "Import Time Off"
    },
    multiple_delete_shift: "Bulk Shift Delete",
    multiple_upload_shift: "Bulk Shift Upload",
    multiple_actions: "Bulk Actions",
    send_email_and_sms_notification: "Send E-mail & SMS Notification",
    add_expense: "Add Expense",
    add_imprest: "Request An Imprest",
    add_overtime: "Request An Overtime",
    add_leave_request: "Request Time Off",
    evaluatee: "Evaluatee",
    add_skill: "Add Skill",
    sign: "Sign",
    skip: "Skip",
    back_to_home: "Back to Home",
    please_select: "Please select..."
  },
  response: {
    success: {
      ok: "The operation is successful",
      update: "Updated Successfully",
      delete: "Deleted Successfully",
      send_sms_password_code: "Password reset code was sent as SMS message"
    },
    error: {
      user_not_found: "Username or password is invalid",
      network_error: "Network Error"
    }
  },
  request_status: {
    PENDING: "Pending Approve",
    pending: "Pending Approve",
    approved: "Approved",
    APPROVED: "Approved",
    denied: "Denied",
    DENIED: "Denied",
    cancelled: "Cancelled",
    CANCELLED: "Cancelled",
    NEED_EXTRA_DETAIL: "Need Extra Detail",
    need_extra_detail: "Need Extra Detail",
    undefined: "Undefined"
  },
  shift_types: {
    FIX: "Fix",
    FLEXIBLE: "Flexible",
    OFF_DAY: "Off Day",
    OFFDAY: "Off Day",
    HOLIDAY: "Holiday",
    WORKDAY: "Workday",
    BREAK: "Break",
    OVERTIME: "Overtime",
    OVERTIME_SHIFT: "Overtime",
    ON_LEAVE: "On Time Off"
  },
  shift: {
    overtime: "Overtime",
    missing_time: "Missing Time",
    shift_parameters: "Shift Parameters",
    break: "Break",
    sub_events: "Sub Events",
    included_calculation: "Included in the calculation",
    not_included_calculation: "Not included in the calculation",
    included_overtime_calculation: "Overtime is not included in the calculation",
    not_included_overtime_calculation: "Overtime is included in the calculation",
    not_included_missing_time_calculation: "Missing time is not included in the calculation",
    included_missing_time_calculation: "Missing time is  included in the calculation",
    work_day: "Work Day",
    overtime_day: "Overtime Day",
    full_time: "Full Time",
    absent: "Absent",
    unpaid_leave: "Unpaid Time Off",
    paid_leave: "Paid Time Off",
    public_holiday: "Public Holiday",
    on_leave: "On Time Off",
    off_day: "Off Day",
    break_day: "Break Day",
    incalculable: "Incalculable Shift"
  },
  sensors: {
    NFC: "Nfc",
    FACE: "Face",
    RFID: "Rfid",
    FINGER: "Fingerprint",
    BLUETOOTH: "Bluetooth",
    GATEWARE: "Gateware",
    BEACON: "Beacon",
    GPS: "Gps",
    WIFI: "Wifi",
    ID: "Id",
    QR: "Qr",
    QR_CODE: "QR Code",
    PASSWORD: "Password",
    PIN: "Pin",
    CARD: "Card",
    FIXED: "Fixed",
    EXTERNAL: "External",
    JAN: "JAN",
    WEB: "Web"
  },
  identity_type: {
    FACE: "Face",
    PASSWORD: "Password",
    PIN: "Pin",
    FINGER: "Fingerprint",
    QR_CODE: "QR Code",
    CARD: "Card",
    EXTERNAL: "External"
  },
  event_types: {
    BREAK_IN: "Break In",
    BREAK_OUT: "Break Out",
    LUNCH_IN: "Lunch In",
    LUNCH_OUT: "Lunch Out",
    DUTY_IN: "Duty In",
    DUTY_OUT: "Duty Out",
    CLOCK_IN: "Clock In",
    CLOCK_OUT: "Clock Out",
    HOME_CLOCK_IN: "Home Clock In",
    HOME_CLOCK_OUT: "Home Clock Out",
    TRAINING_IN: "Training In",
    TRAINING_OUT: "Training Out",
    UNKNOWN: "In or Out",
    undefined: "Unknown"
  },
  currency: {
    amount: "Amount",
    code: "Code",
    requested_amount: "Requested Amount",
    approved_amount: "Approved Amount",
    codes: {
      TRY: "TRY",
      USD: "USD",
      EUR: "EUR"
    }
  },
  titles: {
    expense: {
      create: "Add Expense",
      detail: "Expense Detail"
    },
    imprest: {
      create: "Add Imprest",
      detail: "Imprest Detail"
    }
  },
  language: {
    tr: "Turkish",
    en: "English",
    de: "Deutsch",
    TURKISH: "Turkish",
    ENGLISH: "English",
    GERMAN: "Deutsch"
  },
  status: {
    active: "Active",
    passive: "Passive",
    enable: "Enable",
    disable: "Disable"
  },
  gender: {
    male: "Male",
    female: "Female",
    other: "Other",
    others: "Others",
    MALE: "Male",
    FEMALE: "Female",
    OTHER: "Other"
  },
  marital_status: {
    married: "Married",
    single: "Single",
    divorced: "Divorced"
  },
  education: {
    student: "Student",
    primary_school: "Primary School",
    secondary_school: "Secondary School",
    high_school: "High School",
    collage: "Collage",
    university: "University",
    master: "Master",
    phd: "PhD"
  },
  education_languages: {
    turkish: "Turkish",
    english: "English",
    german: "German",
    french: "French",
    dutch: "Dutch",
    spanish: "Spanish",
    italian: "İtalian",
    arabic: "Arabic",
    russian: "Russian",
    persian: "Persian",
    chinese: "Chinese",
    japanese: "Japanese",
    hindi: "Hindi",
    latin: "Latin",
    portuguese: "Portoguese",
    korean: "Korean"
  },
  military_service: {
    done: "Done",
    undone: "Undone",
    exempt: "Exempt",
    suspended: "Suspended"
  },
  academic_title: {
    lecturer: "Lecturer",
    research_assistant: "Research Assistant",
    assistant_professor: "Assistant Proffessor",
    associate_professor: "Associate Proffessor",
    professor: "Professor"
  },
  employment_type: {
    full_time: "Full Time",
    part_time: "Part Time",
    casual: "Casual",
    contracted: "Contracted",
    freelance: "Freelancer",
    intern: "Intern",
    mobile: "Mobile",
    retired: "Retired",
    trial: "Trial",
    seasonal: "Seasonal",
    disabled: "Disabled"
  },
  collar_type: {
    white: "White",
    blue: "Blue",
    gray: "Gray"
  },
  quite_job_reasons: {
    resignation: "Resignation",
    cancellation_of_labor_contract: "Cancellation of Labor Contract",
    military_service: "Military Service",
    other: "Other"
  },
  blood_type: {
    o_rh_negative: "0-",
    o_rh_positive: "0+",
    a_rh_negative: "A-",
    a_rh_positive: "A+",
    b_rh_negative: "B-",
    b_rh_positive: "B+",
    ab_rh_negative: "AB-",
    ab_rh_positive: "AB+"
  },
  time_duration: {
    hour: "Hour",
    minute: "Minute",
    second: "Second"
  },
  date: {
    year: "Year",
    month: "Month",
    day: "Day",
    time: "Time",
    week: "Week",
    minute: "Minute"
  },
  validations: {
    messages: {
      phone: "The {_field_} field must be a valid phone number",
      password_match: "Passwords don't match",
      password_math: "Passwords don't match",
      integer: "The {_field_} field must be an integer",
      date: "Enter a valid date format (yyyy-mm-dd)"
    }
  },
  nationalities: {
    Afghan: "Afghan",
    Albanian: "Albanian",
    Algerian: "Algerian",
    American: "American",
    Andorran: "Andorran",
    Angolan: "Angolan",
    Antiguans: "Antiguans",
    Argentinean: "Argentinean",
    Armenian: "Armenian",
    Australian: "Australian",
    Austrian: "Austrian",
    Azerbaijani: "Azerbaijani",
    Bahamian: "Bahamian",
    Bahraini: "Bahraini",
    Bangladeshi: "Bangladeshi",
    Barbadian: "Barbadian",
    Barbudans: "Barbudans",
    Botswana: "Botswana",
    Belarusian: "Belarusian",
    Belgian: "Belgian",
    Belizean: "Belizean",
    Beninese: "Beninese",
    Bhutanese: "Bhutanese",
    Bolivian: "Bolivian",
    Bosnian: "Bosnian",
    Brazilian: "Brazilian",
    British: "British",
    Bruneian: "Bruneian",
    Bulgarian: "Bulgarian",
    Burkinabe: "Burkinabe",
    Burmese: "Burmese",
    Burundian: "Burundian",
    Cambodian: "Cambodian",
    Cameroonian: "Cameroonian",
    Canadian: "Canadian",
    "Cape Verdean": "Cape Verdean",
    "Central African": "Central African",
    Chadian: "Chadian",
    Chilean: "Chilean",
    Chinese: "Chinese",
    Colombian: "Colombian",
    Comoran: "Comoran",
    Congolese: "Congolese",
    "Costa Rican": "Costa Rican",
    Croatian: "Croatian",
    Cuban: "Cuban",
    Cypriot: "Cypriot",
    Czech: "Czech",
    Danish: "Danish",
    Djibouti: "Djibouti",
    Dominican: "Dominican",
    Dutch: "Dutch",
    "East Timorese": "East Timorese",
    Ecuadorean: "Ecuadorean",
    Egyptian: "Egyptian",
    Emirian: "Emirian",
    "Equatorial Guinean": "Equatorial Guinean",
    Eritrean: "Eritrean",
    Estonian: "Estonian",
    Ethiopian: "Ethiopian",
    Fijian: "Fijian",
    Filipino: "Filipino",
    Finnish: "Finnish",
    French: "French",
    Gabonese: "Gabonese",
    Gambian: "Gambian",
    Georgian: "Georgian",
    German: "German",
    Ghanaian: "Ghanaian",
    Greek: "Greek",
    Grenadian: "Grenadian",
    Guatemalan: "Guatemalan",
    "Guinea-Bissauan": "Guinea-Bissauan",
    Guinean: "Guinean",
    Guyanese: "Guyanese",
    Haitian: "Haitian",
    Herzegovinian: "Herzegovinian",
    Honduran: "Honduran",
    Hungarian: "Hungarian",
    "I-Kiribati": "I-Kiribati",
    Icelander: "Icelander",
    Indian: "Indian",
    Indonesian: "Indonesian",
    Iranian: "Iranian",
    Iraqi: "Iraqi",
    Irish: "Irish",
    Israeli: "Israeli",
    Italian: "Italian",
    Ivorian: "Ivorian",
    Jamaican: "Jamaican",
    Japanese: "Japanese",
    Jordanian: "Jordanian",
    Kazakhstani: "Kazakhstani",
    Kenyan: "Kenyan",
    "Kittian and Nevisian": "Kittian and Nevisian",
    Kuwaiti: "Kuwaiti",
    Kyrgyz: "Kyrgyz",
    Laotian: "Laotian",
    Latvian: "Latvian",
    Lebanese: "Lebanese",
    Liberian: "Liberian",
    Libyan: "Libyan",
    Liechtensteiner: "Liechtensteiner",
    Lithuanian: "Lithuanian",
    Luxembourger: "Luxembourger",
    Macedonian: "Macedonian",
    Malagasy: "Malagasy",
    Malawian: "Malawian",
    Malaysian: "Malaysian",
    Maldivan: "Maldivan",
    Malian: "Malian",
    Maltese: "Maltese",
    Marshallese: "Marshallese",
    Mauritanian: "Mauritanian",
    Mauritian: "Mauritian",
    Mexican: "Mexican",
    Micronesian: "Micronesian",
    Moldovan: "Moldovan",
    Monacan: "Monacan",
    Mongolian: "Mongolian",
    Moroccan: "Moroccan",
    Mosotho: "Mosotho",
    Motswana: "Motswana",
    Mozambican: "Mozambican",
    Namibian: "Namibian",
    Nauruan: "Nauruan",
    Nepalese: "Nepalese",
    "New Zealander": "New Zealander",
    Nicaraguan: "Nicaraguan",
    Nigerian: "Nigerian",
    Nigerien: "Nigerien",
    "North Korean": "North Korean",
    "Northern Irish": "Northern Irish",
    Norwegian: "Norwegian",
    Omani: "Omani",
    Pakistani: "Pakistani",
    Palauan: "Palauan",
    Panamanian: "Panamanian",
    "Papua New Guinean": "Papua New Guinean",
    Paraguayan: "Paraguayan",
    Peruvian: "Peruvian",
    Polish: "Polish",
    Portuguese: "Portuguese",
    Qatari: "Qatari",
    Romanian: "Romanian",
    Russian: "Russian",
    Rwandan: "Rwandan",
    "Saint Lucian": "Saint Lucian",
    Salvadoran: "Salvadoran",
    Samoan: "Samoan",
    "San Marinese": "San Marinese",
    "Sao Tomean": "Sao Tomean",
    Saudi: "Saudi",
    Scottish: "Scottish",
    Senegalese: "Senegalese",
    Serbian: "Serbian",
    Seychellois: "Seychellois",
    "Sierra Leonean": "Sierra Leonean",
    Singaporean: "Singaporean",
    Slovakian: "Slovakian",
    Slovenian: "Slovenian",
    "Solomon Islander": "Solomon Islander",
    Somali: "Somali",
    "South African": "South African",
    "South Korean": "South Korean",
    Spanish: "Spanish",
    "Sri Lankan": "Sri Lankan",
    Sudanese: "Sudanese",
    Surinamer: "Surinamer",
    Swazi: "Swazi",
    Swedish: "Swedish",
    Swiss: "Swiss",
    Syrian: "Syrian",
    Taiwanese: "Taiwanese",
    Tajik: "Tajik",
    Tanzanian: "Tanzanian",
    Thai: "Thai",
    Togolese: "Togolese",
    Tongan: "Tongan",
    "Trinidadian or Tobagonian": "Trinidadian or Tobagonian",
    Tunisian: "Tunisian",
    Turkish: "Turkish",
    Tuvaluan: "Tuvaluan",
    Ugandan: "Ugandan",
    Ukrainian: "Ukrainian",
    Uruguayan: "Uruguayan",
    Uzbekistani: "Uzbekistani",
    Venezuelan: "Venezuelan",
    Vietnamese: "Vietnamese",
    Welsh: "Welsh",
    Yemenite: "Yemenite",
    Zambian: "Zambian",
    Zimbabwean: "Zimbabwean"
  },
  disability_level: {
    first_level: "First Level",
    second_level: "Second Level",
    third_level: "Third Level"
  },
  social_security_type: {
    SS_4A: "4A",
    SS_4B: "4B",
    SS_4C: "4C"
  },
  days: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday"
  },
  api_error: {
    "401": "Your e-mail or password is incorrect",
    "403": "Your role is not authorized to login",
    "700": "Bad Request",
    "701": "Missing Request Parameter",
    "702": "Unsupported Media Type",
    "703": "Invalid Method Argument",
    "704": "Constraint Violation",
    "705": "Http Message Not Readable",
    "706": "Http Message Not Writable",
    "707": "Field Integrity Violation",
    "708": "Method Argument Type Mismatch",
    "711": "Entity Not Found",
    "712": "Property Not Found",
    "713": "File Size Too Big",
    "714": "Requested Media Not Found",
    "715": "Bad Credentials",
    "716": "Invalid Entity Operation",
    "717": "Invalid Excel Format",
    "718": "You must wait at least 3 minutes to reset a new password",
    "719": "Password reset code has expired",
    "720": "Suprema SDK Error",
    "750": "No Refresh Token",
    "751": "Data Conflict Exception",
    "752": "Illegal Registration Exception",
    "753": "Data Integrity Violation Exception",
    "754": "Email Cannot Be Send",
    "755": "Quota Exceeded Exception",
    "756": "Time Off Request Exists",
    "757": "You must wait at least 3 minutes before you can request a new code",
    "758": "Sms code expired",
    "759": "Failed to verify sms code",
    "760": "Competency items not entered",
    "762": "You are not in the active evaluation period"
  }
};
